import { urlRegex, videoUrlRegex, slugRegex } from '@util/CustomValidation.js'

const nameError = 'Product Name is required and must not be greater than 100 characters.'
const nameDescription = 'Maximum length: 100 characters'
const summaryError = 'Summary must not be greater than 100 characters'
const summaryDescription = 'Provide a short sentence that summarizes the purpose of your product. Maximum length: 100 characters'//eslint-disable-line
const longDescriptionError = 'Long Description is required and must not be greater than 5,000 characters.'
const longDescription = 'Enter a full description of your product and its features. This information may be used to assess your product during the approval process. (Max 5,000 characters)' //eslint-disable-line
const shortDescriptionError = 'Short Description is required and must not be greater than 500 characters.'
const shortDescription = 'Provide a brief summary of your product. This information may be used to assess your product during the approval process. Maximum length: 500 characters' //eslint-disable-line
const usefulResourceDescriptionError = 'Description must not be greater than 130 characters.'
const usefulResourceDescription = 'Brief description of the resource. Maximum length: 130 characters'
const usefulResourceImageError = 'Valid image is required'
const usefulResourceTitleDescription = 'Maximum length: 255 characters'
const usefulResourceTitleError = 'Title is required and must be under 255 characters'
const usefulResourceTypeDescription = 'Editorial links will be treated as index/follow.\nSponsored links will be treated as noindex/nofollow.' //eslint-disable-line
const usefulResourceURLDescription = 'Enter a valid URL for the resource website.'
const URLError = "URL is required, must be under 2000 characters, and must be a fully valid URL, for example: 'https://www.technologyadvice.com/landing-page'. A lone '%' is not allowed; if present, it must be followed by two hex digits (e.g., %3A)." //eslint-disable-line
const URLDescription = "Add your product's main link"
const videoUrlError = 'Enter a video URL that starts with any of the following: https://www.youtube.com/, https://youtube.com/, youtu.be/, https://vimeo.com/, https://player.vimeo.com/' //eslint-disable-line
const extendedDescription = 'Editorial use only. Enter a full overview of the product, its features, and alternatives.\nMaximum length: 100,000 character' //eslint-disable-line
const extendedDescriptionError = 'Extended Description must not be greater than 100,000 characters.' //eslint-disable-line
const slugError = 'The Product URL Path may not exceed 100 characters and may only contain lowercase letters, numbers, and dashes (-).' //eslint-disable-line
const slugAlreadyTaken = 'This slug is already in use'

const productDeleteInfo = name => ({
    title: `Are you sure you want to permanently delete ${name}?`,
    html: `
            <p style="text-align: left;">This action cannot be undone.
            The following items will also be deleted:</p>
            <div style="text-align: left;">
            <li>Any ads associated with this product</li>
            <li>Any programs associated with this product</li>
            <li>Any targeting sets associated with this product</li>
            </div>
        `,
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Delete',
    reverseButtons: true,
})

const displayInProductCatalogInfo = () => ({
    title: 'Are you sure you want display this product in the product catalog?',
    icon: 'warning',
    html: `
            <p style="text-align: center;">
                This action will add this product back to the product listings on
                Technologyadvice.com regardless of product approval status.</p>
            <p style="text-align: center;">Please notify the SEO team so they can take appropriate action.</p>
        `,
    showCancelButton: true,
    confirmButtonText: 'Confirm',
    reverseButtons: true,
})

const hideInProductCatalogInfo = () => ({
    title: 'Are you sure you want to hide this product from the product catalog?',
    icon: 'warning',
    html: `
            <p style="text-align: center;">
                This action will remove this product from the product listings on
                Technologyadvice.com regardless of product approval status.</p>
            <p style="text-align: center;">Please notify the SEO team so they can take appropriate action.</p>
        `,
    showCancelButton: true,
    confirmButtonText: 'Confirm',
    reverseButtons: true,
})

const productScreenshotDeleteInfo = image => ({
    title: `Are you sure you want to delete ${image.name}?`,
    text: 'This cannot be undone',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Delete',
    reverseButtons: true,
})

const ctaButtonTextOptions = [
    'Visit Website',
    'Try For Free',
    'Book a Demo',
];

const promotionalFieldsTooltipText = 'This feature is available with an Enhanced Profile. Upgrade to drive traffic to your landing page.' //eslint-disable-line

export const productFormInfo = {
    regex: urlRegex,
    videoRegex: videoUrlRegex,
    slugRegex,
    nameError,
    nameDescription,
    summaryError,
    summaryDescription,
    longDescriptionError,
    longDescription,
    shortDescriptionError,
    shortDescription,
    usefulResourceDescription,
    usefulResourceDescriptionError,
    usefulResourceImageError,
    usefulResourceTitleDescription,
    usefulResourceTitleError,
    usefulResourceTypeDescription,
    usefulResourceURLDescription,
    URLError,
    URLDescription,
    productDeleteInfo,
    videoUrlError,
    extendedDescription,
    extendedDescriptionError,
    slugError,
    slugAlreadyTaken,
    productScreenshotDeleteInfo,
    displayInProductCatalogInfo,
    hideInProductCatalogInfo,
    ctaButtonTextOptions,
    promotionalFieldsTooltipText,
}
